import { create } from '@wix/fedops-logger';

const fedopsLogger = create('wix-vod-embed-video', {
  /* options */
});

const createInteraction = (name) => ({
  start: () => {
    fedopsLogger.interactionStarted(name);
    // console.log(`[start] ${name}`);
  },
  end: () => {
    fedopsLogger.interactionEnded(name);
    // console.log(`[end] ${name}`);
  },
});

const createImmediateInteraction = (name) => () => {
  const { start, end } = createInteraction(name);

  start();
  end();
};

export const fedopsInteractions = {
  playVideoDesktop: createInteraction('PLAY_VIDEO_DESKTOP'),
  playVideoMobile: createInteraction('PLAY_VIDEO_MOBILE'),
  errorStateShown: createImmediateInteraction('ERROR_STATE_SHOWN'),
};

export const appLoaded = () => fedopsLogger.appLoaded();
